import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { AppUtilityService } from '../../services/app-utility.service';
import { LocoIncidentService } from '../../services/loco-incident-service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { IntendedUsageReasonVO } from './../../model/intended-usage-reason-vo';
import { IntendedUsageVO } from './../../model/intended-usage-vo';
import { LocoConditionVO } from './../../model/loco-condition-vo';


@Component({
  selector: 'lms-intended-usage',
  templateUrl: './lms-intended-usage.component.html',
  styleUrls: ['./lms-intended-usage.component.scss']
})
export class LmsIntendedUsageComponent implements OnInit, OnChanges {

  private commonopsPicklist;
  @Input() locoData: LocoDetail;
  @Input() indexPosition: number;
  selectedIntendedUsageCode: string;
  selectedIntendedUsageReasonCode: IntendedUsageReasonVO;
  intendedUsageCodes: Array<SelectItem> = [];
  intendedUsageReason: Array<SelectItem> = [];
  isNoteMandatory: boolean;
  isNoteAvailable: boolean;
  showDeleteIcon: boolean;
  isRequired: boolean;
  @Input() tabLevel: number;
  @Input() isUpdateIntenedUsage: boolean;

  constructor(private staticDataStoreService: StaticDataStoreService,
    private apUtilityService: AppUtilityService,
    private locoIncidentService: LocoIncidentService) {
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');

  }

  /**
   * Initialize intended usage dropdown values.
   * @memberof LmsIntendedUsageComponent
   */
  initIntendedUsageCodes() {
    this.intendedUsageCodes = [];
    if (this.commonopsPicklist && this.commonopsPicklist.intendedUsageDataVO && this.commonopsPicklist.intendedUsageDataVO.intendedUsageVoList) {
      for (let i = 0; i < this.commonopsPicklist.intendedUsageDataVO.intendedUsageVoList.length; i++) {
        const intendedUsageVO: IntendedUsageVO = this.commonopsPicklist.intendedUsageDataVO.intendedUsageVoList[i];
        this.intendedUsageCodes.push({
          label: intendedUsageVO.intendedUsageLongX,
          value: intendedUsageVO.intendedUsageC
        });
      }
    }
  }

  /**
  * Initialize the state of lifecycle hook.
  * @memberof LmsIntendedUsageComponent
  */
  ngOnInit() {
    this.init();
  }

  init() {
    this.isNoteMandatory = false;
    this.isNoteAvailable = false;
    if (this.locoData && !this.isUpdateIntenedUsage) {
      this.locoData.intendedUsageNote = '';
    }
    // const locoStatus = '4-ax'; // need to get from selected locomotive
    this.initIntendedUsageCodes();
    if (this.isUpdateIntenedUsage && this.locoData.intendedUsageCode) {
      this.selectedIntendedUsageCode = this.locoData.intendedUsageCode;
    } else {
      if (this.locoData && this.locoData.locoIncident && this.commonopsPicklist && this.commonopsPicklist.intendedUsageDataVO && this.commonopsPicklist.intendedUsageDataVO.locoConditionVoList) {
        for (let i = 0; i < this.commonopsPicklist.intendedUsageDataVO.locoConditionVoList.length; i++) {
          const locoConditionVO: LocoConditionVO = this.commonopsPicklist.intendedUsageDataVO.locoConditionVoList[i];
          if (this.locoData.locoIncident.trim().toUpperCase() === locoConditionVO.locomotiveConditionC.trim().toUpperCase()) {
            this.selectedIntendedUsageCode = locoConditionVO.defaultIntendedUsageCode;
            this.locoData.intendedUsageCode = locoConditionVO.defaultIntendedUsageCode;
            break;
          }
        }
      }
    }
    this.setintendedUsageReson();
  }

  ngOnChanges() {
    this.init();
  }

  /**
   * Set Intended usage reason list and default selection for update intended usage.
   * @memberof LmsIntendedUsageComponent
   */
  setIncidentReasonForUpdate(isValueChange?: boolean) {
    if (this.locoData && this.locoData.locoIncident && this.commonopsPicklist && this.commonopsPicklist.intendedUsageDataVO && this.commonopsPicklist.intendedUsageDataVO.intendedUsageReasonVoList) {
      for (let i = 0; i < this.commonopsPicklist.intendedUsageDataVO.intendedUsageReasonVoList.length; i++) {
        const intendedUsageReasonVO: IntendedUsageReasonVO = this.commonopsPicklist.intendedUsageDataVO.intendedUsageReasonVoList[i];
        if (this.selectedIntendedUsageCode && intendedUsageReasonVO && (this.locoData.locoIncident.trim().toUpperCase() === intendedUsageReasonVO.locomotiveConditionC.trim().toUpperCase()) &&
          (intendedUsageReasonVO.intendedUsageC.trim().toUpperCase() === this.selectedIntendedUsageCode.trim().toUpperCase())) {
          const intendedUsageReasonDesc = this.apUtilityService.getIntendedUsageReasonDesc(intendedUsageReasonVO.usageReasonC);
          this.intendedUsageReason.push({
            label: intendedUsageReasonDesc, value: intendedUsageReasonVO
          });
          if (!isValueChange && this.isUpdateIntenedUsage && this.locoData.intendedUsageReason
            && intendedUsageReasonVO.usageReasonC && intendedUsageReasonVO.usageReasonC.trim().toUpperCase() === this.locoData.intendedUsageReason.trim().toUpperCase()) {
            this.selectedIntendedUsageReasonCode = intendedUsageReasonVO;
            if (this.locoData.intendedUsageNote) {
              this.isNoteAvailable = true;
            } else {
              this.isNoteAvailable = false;
            }
          } else if (intendedUsageReasonVO.defaultConditionCodeS === '1') {
            this.selectedIntendedUsageReasonCode = intendedUsageReasonVO;
            this.isNoteAvailable = false;
          }
        }
      }
    }
    if (!this.selectedIntendedUsageReasonCode && this.intendedUsageReason && this.intendedUsageReason.length > 0 && this.intendedUsageReason[0].value) {
      this.locoData.intendedUsageReason = this.intendedUsageReason[0].value.usageReasonC;
    }
  }
  /**
     * Set Intended usage reason list and default selection for plan.
     * @memberof LmsIntendedUsageComponent
     */
  setIncidentReasonForDefault() {
    if (this.locoData && this.locoData.locoIncident && this.commonopsPicklist && this.commonopsPicklist.intendedUsageDataVO && this.commonopsPicklist.intendedUsageDataVO.intendedUsageReasonVoList) {
      for (let i = 0; i < this.commonopsPicklist.intendedUsageDataVO.intendedUsageReasonVoList.length; i++) {
        const intendedUsageReasonVO: IntendedUsageReasonVO = this.commonopsPicklist.intendedUsageDataVO.intendedUsageReasonVoList[i];
        if (this.selectedIntendedUsageCode && intendedUsageReasonVO && (this.locoData.locoIncident.trim().toUpperCase() === intendedUsageReasonVO.locomotiveConditionC.trim().toUpperCase()) &&
          (intendedUsageReasonVO.intendedUsageC.trim().toUpperCase() === this.selectedIntendedUsageCode.trim().toUpperCase())) {
          const intendedUsageReasonDesc = this.apUtilityService.getIntendedUsageReasonDesc(intendedUsageReasonVO.usageReasonC);
          this.intendedUsageReason.push({
            label: intendedUsageReasonDesc, value: intendedUsageReasonVO
          });
          if (intendedUsageReasonVO.defaultConditionCodeS === '1') {
            this.locoData.intendedUsageReason = intendedUsageReasonVO.usageReasonC;
            this.selectedIntendedUsageReasonCode = intendedUsageReasonVO;
            if (intendedUsageReasonVO.formTextRequiredS === '1') {
              this.locoData.intendedUsgaeNoteRequired = true;
              this.locoData.intendedUsageNote = '';
              this.isNoteMandatory = true;
              this.showDeleteIcon = true;
              this.isRequired = true;
            }
          }
        }
      }
    }
    if (!this.selectedIntendedUsageReasonCode && this.intendedUsageReason && this.intendedUsageReason.length > 0 && this.intendedUsageReason[0].value) {
      this.locoData.intendedUsageReason = this.intendedUsageReason[0].value.usageReasonC;
    }
  }

  /**
   * Set intended usage reason dropdown values.
   * @memberof LmsIntendedUsageComponent
   */
  setintendedUsageReson(isValueChange?: boolean) {
    this.intendedUsageReason = [];
    if (this.isUpdateIntenedUsage) {
      this.setIncidentReasonForUpdate(isValueChange);
    } else {
      this.setIncidentReasonForDefault();
    }
  }

  /**
   * Invoked when intended usage dropdown value change.
   * @memberof LmsIntendedUsageComponent
   */
  changeIntendedUsageCode() {
    this.locoData.intendedUsageCode = this.selectedIntendedUsageCode;
    this.intendedUsageReason = [];
    this.setintendedUsageReson(true);
    // this.locoData.intendedUsageReason = this.selectedIntendedUsageReasonCode.usageReasonC;
    this.changeIntendedUsageReasonCode(false);
  }

  /**
   * Invoked when intended usage reason value change.
   * @param {boolean} directReasonChange
   * @memberof LmsIntendedUsageComponent
   */
  changeIntendedUsageReasonCode(directReasonChange: boolean) {
    if (directReasonChange) {
      this.locoData.intendedUsageReason = this.selectedIntendedUsageReasonCode.usageReasonC;
    }
    this.clearNoteText();
    this.locoData.isIntendedUsageNotError = false;
    this.isNoteMandatory = false;
    this.locoData.intendedUsgaeNoteRequired = false;
    this.showDeleteIcon = false;
    for (let i = 0; i < this.intendedUsageReason.length; i++) {
      if (this.selectedIntendedUsageReasonCode.usageReasonC === this.intendedUsageReason[i].value.usageReasonC) {
        if (this.intendedUsageReason[i].value.formTextRequiredS === '1') {
          this.locoData.intendedUsgaeNoteRequired = true;
          this.isNoteMandatory = true;
          this.showDeleteIcon = true;
          this.isRequired = true;
          this.setFocusToTextArea();
        }
      }
    }
  }

  /**
   * open note box.
   * @memberof LmsIntendedUsageComponent
   */
  createNote() {
    this.isNoteMandatory = true;
    this.setFocusToTextArea();
  }

  private setFocusToTextArea() {
    setTimeout(() => {
      const textBox = document.getElementById('intdUsgNoteText' + this.indexPosition);
      if (textBox) {
        textBox.focus();
      }
    }, 50);
  }

  /**
   * Invoked when close note text box by click on cross icon.
   * @memberof LmsIntendedUsageComponent
   */
  closeNote() {
    this.isNoteMandatory = false;
    this.isNoteAvailable = false;
    this.clearNoteText();
  }

  /**
   * Invoked for clear note text.
   * @memberof LmsIntendedUsageComponent
   */
  clearNoteText() {
    this.locoData.intendedUsageNote = '';
  }

  /**
   * Get formmated locomotive id.
   * @returns
   * @memberof LmsIntendedUsageComponent
   */
  getLocomotiveId() {
    if (this.locoData && this.locoData.locomotiveIdentifier) {
      return this.apUtilityService.UIformatLocomotiveId(this.locoData.locomotiveIdentifier);
    }
    return '';
  }
}
